import { URLS } from '@constants'
import {
  GETEntityColumn,
  PayloadCreateViewColumn,
  POSTCreateAllColumns,
  POSTOrderColumnType,
  POSTTitleColumnType,
  POSTVisibilityColumnType,
} from '@types'

import { commonAPI } from './common.api'

export const columnAPI = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchColumnView: build.mutation<GETEntityColumn, number | string | void>({
      query: id => ({
        url: URLS.FRONT_CFG + `/column/id/${id}`,
      }),
    }),
    createColumnView: build.mutation<GETEntityColumn, PayloadCreateViewColumn>({
      query: column => ({
        url: URLS.FRONT_CFG + '/column',
        method: 'POST',
        body: { ...column, id: undefined },
      }),
      invalidatesTags: ['SingleView'],
    }),
    createAllColumns: build.mutation<GETEntityColumn, POSTCreateAllColumns>({
      query: allColumnsParams => ({
        url: URLS.FRONT_CFG + '/column/addAll',
        method: 'POST',
        body: { ...allColumnsParams, onlyRequired: false },
      }),
      invalidatesTags: ['SingleView'],
    }),
    deleteAllColumns: build.mutation<GETEntityColumn, POSTCreateAllColumns>({
      query: allColumnsParams => ({
        url: URLS.FRONT_CFG + '/column/all',
        method: 'DELETE',
        body: { ...allColumnsParams, onlyRequired: false },
      }),
      invalidatesTags: ['SingleView'],
    }),
    createMandatoryColumns: build.mutation<GETEntityColumn, POSTCreateAllColumns>({
      query: allColumnsParams => ({
        url: URLS.FRONT_CFG + '/column/addAll',
        method: 'POST',
        body: { ...allColumnsParams, onlyRequired: true },
      }),
      invalidatesTags: ['SingleView'],
    }),
    updateColumnView: build.mutation<GETEntityColumn, PayloadCreateViewColumn>({
      query: column => ({
        url: URLS.FRONT_CFG + '/column',
        method: 'POST',
        body: column,
      }),
      invalidatesTags: ['SingleView'],
    }),
    deleteColumnView: build.mutation<void, number | string>({
      query: id => ({
        url: URLS.FRONT_CFG + `/column/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['SingleView'],
    }),
    updateOrderColumns: build.mutation<void, POSTOrderColumnType[]>({
      query: columns => ({
        url: URLS.FRONT_CFG + '/column/order',
        method: 'POST',
        body: columns,
      }),
      invalidatesTags: ['SingleView'],
    }),
    updateVisibilityColumnById: build.mutation<void, POSTVisibilityColumnType>({
      query: column => ({
        url: URLS.FRONT_CFG + '/column/visibility',
        method: 'POST',
        body: column,
      }),
      invalidatesTags: ['SingleView'],
    }),
    updateColumnTitle: build.mutation<void, POSTTitleColumnType>({
      query: column => ({
        url: URLS.FRONT_CFG + '/column/title',
        method: 'POST',
        body: column,
      }),
      invalidatesTags: ['SingleView'],
    }),
  }),
})

export const {
  useCreateColumnViewMutation,
  useCreateAllColumnsMutation,
  useDeleteAllColumnsMutation,
  useCreateMandatoryColumnsMutation,
  useDeleteColumnViewMutation,
  useFetchColumnViewMutation,
  useUpdateColumnViewMutation,
  useUpdateOrderColumnsMutation,
  useUpdateVisibilityColumnByIdMutation,
  useUpdateColumnTitleMutation,
} = columnAPI
